module.exports = __webpack_public_path__ + "media/ab-homepage/customize-wht-eb48f8ca.png";